<form [formGroup]="form">
  <div class="p-fluid grid">
    <div class="field col-12 d-flex flex-column">
      <label for="paisBolsa">País de Estudo</label>
      <p-select
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        id="paisBolsa"
        formControlName="paisBolsa"
        [options]="paisGenericoList"
        optionLabel="pais"
        optionValue="id"
        placeholder="Seleccione o país de estudo"
        class="w-full"
        (onChange)="onPaisChange()"
      />
      <div *ngIf="form.get('paisBolsa')?.touched && form.get('paisBolsa')?.invalid">
        <small *ngIf="form.get('paisBolsa')?.errors?.['required']">País de estudo é obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="estudanteID">Estudante</label>
      <p-select
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        id="estudanteID"
        formControlName="estudanteID"
        [options]="estudantes"
        optionLabel="nome"
        optionValue="id"
        placeholder="Seleccione o estudante"
        class="w-full"
      ></p-select>
      <div *ngIf="form.get('estudanteID')?.touched && form.get('estudanteID')?.invalid">
        <small *ngIf="form.get('estudanteID')?.errors?.['required']">Estudante é obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column gap-2" *ngIf="form.get('estudanteID')?.value">
      <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
        <span>Tipo de Bolsa: <strong>{{ bolsa?.tipoBolsaDescricao }}</strong></span>
        <span>Instituição Gestora: <strong>{{ bolsa?.instituicaoGestora?.nome }}</strong></span>
        <span>Área de Conhecimento: <strong>{{ bolsa?.areaProgramaFormacao?.areaFormacao?.designacao }}</strong></span>
        <span *ngIf="form.get('valores')?.value">Valor (Bolsa): <strong>{{ form.get('valores')?.value }}</strong></span>
        <span *ngIf="form.get('moeda')?.value">Moeda: <strong>{{ form.get('moeda')?.value }}</strong></span>
      </ng-container>
      <ng-template #emptyTemplate>
        <div class="no-data">
          <app-data-void
            titulo="Nenhum auxílio de Formação encontrado"
            descricao="Seleccione um estudante para carregar os dados."
          ></app-data-void>
        </div>
      </ng-template>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="valorBolsa">Valor da Bolsa</label>
      <input
        id="valorBolsa"
        class="input-number-hide-arrow"
        placeholder="800,00"
        type="text"
        pInputText
        formControlName="valores"
      />
      <div *ngIf="form.get('valores')?.touched && form.get('valores')?.invalid">
        <small *ngIf="form.get('valores')?.errors?.['required']">Valor da Bolsa é obrigatório.</small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column" *ngIf="form.get('valores')?.value">
      <label for="valorExtenso">Valor Extenso da Bolsa</label>
      <input
        id="valorExtenso"
        class="input-number-hide-arrow"
        placeholder="Mil e duzentos e oitenta e seis"
        type="text"
        pInputText
        formControlName="valoresextenso"
      />
      <div *ngIf="form.get('valoresextenso')?.touched && form.get('valoresextenso')?.invalid">
        <small *ngIf="form.get('valoresextenso')?.errors?.['required']">Valor Extenso é obrigatório.</small>
      </div>
    </div>
  </div>
</form>
